import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Sentry — silent no-op until REACT_APP_SENTRY_DSN is set in frontend/.env.
// Catches unhandled React errors and promise rejections, complements the
// backend Sentry wiring so we see the full picture of any prod issue.
if (process.env.REACT_APP_SENTRY_DSN) {
  // Lazy import so unconfigured deployments don't pay the bundle cost.
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_DSN,
      environment: process.env.REACT_APP_SENTRY_ENV || "production",
      tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_SAMPLE_RATE || "0.05"),
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
